export const makeMsisdnBeautiful = (msisdn) => {
  if (!msisdn)
    return null
  msisdn = msisdn.replace(/[^0-9]/g, '')
  if (msisdn.length < 11)
    return null
  return '+7 '.concat(msisdn.slice(1, 4)).concat(' ').concat(msisdn.slice(4, 7)).concat(' ')
    .concat(msisdn.slice(7, 9)).concat(' ').concat(msisdn.slice(9, 11))
}

export const getBalance = (balance) => {
  if (balance === 0 || balance) {
    return `${balance} ₸`
  }
  return `- ₸`
}

export const range = (n) => {
  let array = []
  for (let i = 0; i < n; i++) {
    array.push(i)
  }
  return array
}

export const sort = (l, r) => {
  const ll = l || 0
  const rr = r || 0
  if (ll.length < rr.length) return -1
  if (ll.length > rr.length) return 1
  if (ll < rr) return -1
  if (ll > rr) return 1
  return 0
}

export const optional = (get) => {
  try {
    return get()
  } catch (e) {
    return undefined
  }
}

export const iconByType = (type) => {
  switch (type) {
    case 'INTERNET':
      return "b2b-icon icon-wifi "
    case 'SMS':
      return "b2b-icon icon-post "
    case 'VOICE':
      return "b2b-icon icon-phone-in-talk "
    default:
      return "b2b-icon icon-star "
  }
}

export const capitalizeText = (text) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}